import "./App.css";

import MainPage from "./MainPage";
import { LoginRequired } from "@nike/aegis-auth-react";
import aegisClient from "./authorization/aegisClient";
import { DueDateProvider } from "./contexts/DueDateContext";
function App() {
  return (
    <LoginRequired client={aegisClient}>
      <div style={{ height: 500, backgroundColor: "rgb(30, 30, 47)" }}>
        <DueDateProvider>
          <MainPage />
        </DueDateProvider>
      </div>
    </LoginRequired>
  );
}

export default App;
